import { z } from "zod";
import { ZodSchema } from "@validation/utils/schemaUtils";
import moment from "moment";
import { intl } from "LocaleWrapper";

export const duplicateMultipleContractsSchema = z.object({
	validFrom: ZodSchema.requiredField(z.number()),
	validUntil: ZodSchema.requiredField(z.number()),
}).superRefine((val, ctx) => {
	if (moment(val.validFrom).isAfter(val.validUntil)) {
		ctx.addIssue({
			code: "custom",
			path: [ "validFrom" ],
			message: intl.formatMessage({ id: "CONTRACT_VALID_FROM_BEFORE_VALID_UNTIL" }),
		});
	}
});

export type DuplicateMultipleContractsSchemaInput = z.input<typeof duplicateMultipleContractsSchema>;
export type DuplicateMultipleContractsSchemaOutput = z.output<typeof duplicateMultipleContractsSchema>;


export const extendContractSchema = z.object({
	validUntil: ZodSchema.requiredField(z.number()),
});

export type ExtendContractSchemaInput = z.input<typeof extendContractSchema>;
export type ExtendContractSchemaOutput = z.output<typeof extendContractSchema>;
